import { useEffect, useState } from 'react'

import Menu from '../../../../components/Peyks/Menu'
import peykIcon from '../../../../assets/svg/PPeykMessage.svg'

import { useNavigate, useParams } from 'react-router-dom'
import { notify } from '../../../../components/Toast'

import { useForm } from "react-hook-form"

import { get, post } from '../../../../services/http'
import { ToastContainer } from 'react-toastify'

export default function Index() {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate()
  
  const [clickButton, setClickButton] = useState(false)
  const [peykMessageName, setPeykMessageName] = useState('')
  const [peykMessage, setPeykMesssage] = useState('')
  const [peykMessageTitle, setPeykMessageTitle] = useState('')
  
  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')
  const params = useParams()

  useEffect(() => {
    get(`/api/admin/message-peyks/${params.id}?token=${token}`)
      .then(respose => {
        console.log(respose)
        setPeykMessageName(respose.data.data.peyk[0].name)
        setPeykMessageTitle(respose.data.data.title)
        setPeykMesssage(respose.data.data.messages)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [params.id, token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)
  }

  document.title = 'پیام‌ها'

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'messages'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={peykIcon} width={30} alt='resturantIcon' />
              </div>
              <div className='text'>
                پیغام جدید
              </div>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * تمامی اطلاعات رو پر کنید
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات پیام
              <hr />
            </div>
            <div className='formMessage'>
              {Object.entries(peykMessage).map(([key, value]) => (
                <li key={key}>
                  <strong>{key === 'manager' ? 'مدیر' : 'پیک'}:</strong> {value}
                </li>
              ))}
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>عنوان پیغام * :</label>
                <input id='foodName' defaultValue={peykMessageTitle} readOnly {...register("title", { required: true, minLength: 3 })} type='text' placeholder='مثلا سلام' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>پیک * :</label>
                <input type="text" defaultValue={peykMessageName}  readOnly />
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='foodDetail'>پیغام * :</label>
                <textarea id='foodDetail' rows={5} placeholder='پیغام' {...register("description", { required: true })} />
                <small id='foodDetailAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال ارسال ...' : 'ارسال پیغام'}</button>
          </form>
          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
